export enum CategoryType {
  product = "product",
  thermostat = "thermostat",
  accessory = "accessory",
}
